import { notifyError } from "../../helpers/helpers";
import { auction } from "../config/urlConfig";

export const getGstVerificationData = (id, navigate) => async (dispatch) => {
  dispatch({ type: "SHOW_GST_VERIFICATION" });
  try {
    const { data } = await auction.get(`/authenticate/verify-gstin/${id}`);
    dispatch({ type: "GET_GST_DATA", payload: data });
    navigate(`/verify-gst-details/${id}`);
  } catch (error) {
    notifyError(
      error.response ? error.response?.data : error.message,
      error.response?.status
    );
    dispatch({ type: "CANNOT_GET_GST_DATA" });
  }
};

export const updateGstDetails = (gstData, panCardNumber, navigate) => async (dispatch) => {
  dispatch({ type: "SHOW_GST_VERIFICATION" });
  try {
    const { data } = await auction.put(
      `/profile/update/organization-name`,
      gstData
    );
    dispatch({ type: "UPDATE_GST_DATA", payload: data });
    dispatch(addPanCardNumber(panCardNumber, navigate));
  } catch (error) {
    notifyError(
      error.response ? error.response?.data : error.message,
      error.response?.status
    );
    dispatch({ type: "CANNOT_GET_GST_DATA" });
  }
};

export const addPanCardNumber = (panCardNumber, navigate) => async (dispatch) => {
  dispatch({ type: "PAN_CARD_LOADING" });
  try {
    const { data } = await auction.put(`/organization/update/add-pan-card-number`, {
      panCardNumber,
    });
    dispatch({ type: "PAN_CARD_SUCCESS", payload: data });
    navigate("/uploadDocument");
  } catch (error) {
    notifyError(
      error.response ? error.response?.data : error.message,
      error.response?.status
    );
    dispatch({ type: "PAN_CARD_LOADING" });
  }
}
